import React, { Component } from "react";
import Download from "../Download/download";
import { Translate } from "react-localize-redux";
import Carousel3D from "./Carousel3D.js";

class Hero extends Component {
  render() {
    return (
      <div>
        <div className="hero-container">
          <Carousel3D />
          <div className="hero-content">
            <h1 className="hero-title">Мэдрэмжээ sonsy</h1>

            <p className="hero-description">
              <Translate id="home.hero-desc1" />
              <br />
              <Translate id="home.hero-desc2" />
            </p>

            <Download />
          </div>
        </div>
      </div>
    );
  }
}

export default Hero;
